import type React from 'react';
import { Helmet } from './Helmet';

interface PageSEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  children?: React.ReactNode;
}

export default function PageSEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  children,
}: PageSEOProps) {
  return <Helmet title={title} description={description} keywords={keywords} canonicalUrl={canonicalUrl} ogType={ogType}>{children}</Helmet>;
}